import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetInvoiceNumbersForHistoryQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.InvoiceDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.InvoiceDocumentSortInput> | Types.InvoiceDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetInvoiceNumbersForHistoryQuery = { __typename?: 'Query', invoices?: { __typename?: 'InvoicesConnection', totalCount: number, nodes?: Array<{ __typename?: 'InvoiceDocument', invoiceId: string, invoiceNumber: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type InvoiceLineRowFragment = { __typename?: 'InvoiceLineData', itemId: string, itemName: string, sku: string, lineItemId: string, lineNumber: number, shippedQuantity: number, unitPrice: number, discountAmount: number, extended: number, taxAmount: number, eachesPerUnit?: number | null, units?: number | null, shippingUomLabel?: string | null };

export type InvoiceTaxJurisdictionRowFragment = { __typename?: 'InvoiceTaxJurisdictionData', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string };

export type InvoiceTermsRowFragment = { __typename?: 'InvoiceTermsSnapshotData', termLimitDays: number, discountDays: number, discountRate: number, lateChargeMonthlyRate: number, maxAnnualRate: number };

export type InvoicePaymentRowFragment = { __typename?: 'InvoicePaymentEntry', streamRevision: number, amount: number, method: Types.InvoicePaymentMethod, transactionRef?: string | null, receivedDate: Types.TDateISO, discountTaken: number, lateChargeAssessed: number, recordedBy: string, note?: string | null, recordedAt: Types.TDateISO, paymentId?: string | null, paymentSyncStatus: Types.PaymentSyncStatus, accountingPaymentId?: string | null, syncFailureReason?: string | null };

export type QuickBooksExportStateRowFragment = { __typename?: 'QuickBooksExportState', status: Types.QuickBooksExportStatus, remoteInvoiceId?: string | null, errorMessage?: string | null, lastAttemptAt?: Types.TDateISO | null, retryCount: number, resolvedRevenueRung?: Types.MergeDevRevenueRung | null, resolvedRevenueAccount?: { __typename?: 'MergeDevAccountDocument', accountNumber: string, name: string } | null };

export type InvoiceCreditApplicationRowFragment = { __typename?: 'InvoiceCreditApplicationEntry', applicationId: string, amount: number, appliedAt: Types.TDateISO, sources: Array<{ __typename?: 'InvoiceCreditSourceEntry', entryId: string, sourceKind: Types.CustomerCreditSourceKind, sourceReference: string, amount: number }> };

export type InvoiceDetailFragment = { __typename?: 'InvoiceDocument', id: string, invoiceId: string, orderId: string, invoiceNumber: string, customerId: string, invoiceDate: Types.TDateISO, dueDate: Types.TDateISO, subtotal: number, freight: number, taxTotal: number, taxStatus: Types.InvoiceTaxStatus, grossTotal: number, depositApplied: number, total: number, issuedAt: Types.TDateISO, issuedBy: string, status: Types.InvoiceStatus, voidReason?: string | null, stripeTaxReversalTransactionId?: string | null, voidedAt?: Types.TDateISO | null, voidedBy?: string | null, amountPaid: number, amountCreditApplied: number, discountTaken: number, lateChargeAssessed: number, openBalance: number, standing: Types.InvoiceStanding, lastPaymentDate?: Types.TDateISO | null, lines: Array<{ __typename?: 'InvoiceLineData', itemId: string, itemName: string, sku: string, lineItemId: string, lineNumber: number, shippedQuantity: number, unitPrice: number, discountAmount: number, extended: number, taxAmount: number, eachesPerUnit?: number | null, units?: number | null, shippingUomLabel?: string | null }>, flatCharges: Array<{ __typename?: 'InvoiceFlatChargeEntry', id: string, name: string, amount: number }>, taxBreakdown: Array<{ __typename?: 'InvoiceTaxJurisdictionData', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }>, terms: { __typename?: 'InvoiceTermsSnapshotData', termLimitDays: number, discountDays: number, discountRate: number, lateChargeMonthlyRate: number, maxAnnualRate: number }, payments: Array<{ __typename?: 'InvoicePaymentEntry', streamRevision: number, amount: number, method: Types.InvoicePaymentMethod, transactionRef?: string | null, receivedDate: Types.TDateISO, discountTaken: number, lateChargeAssessed: number, recordedBy: string, note?: string | null, recordedAt: Types.TDateISO, paymentId?: string | null, paymentSyncStatus: Types.PaymentSyncStatus, accountingPaymentId?: string | null, syncFailureReason?: string | null }>, creditsApplied: Array<{ __typename?: 'InvoiceCreditApplicationEntry', applicationId: string, amount: number, appliedAt: Types.TDateISO, sources: Array<{ __typename?: 'InvoiceCreditSourceEntry', entryId: string, sourceKind: Types.CustomerCreditSourceKind, sourceReference: string, amount: number }> }>, quickBooksExport: { __typename?: 'QuickBooksExportState', status: Types.QuickBooksExportStatus, remoteInvoiceId?: string | null, errorMessage?: string | null, lastAttemptAt?: Types.TDateISO | null, retryCount: number, resolvedRevenueRung?: Types.MergeDevRevenueRung | null, resolvedRevenueAccount?: { __typename?: 'MergeDevAccountDocument', accountNumber: string, name: string } | null } };

export type GetInvoiceQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['String']['input'];
}>;


export type GetInvoiceQuery = { __typename?: 'Query', invoice?: { __typename?: 'InvoiceDocument', id: string, invoiceId: string, orderId: string, invoiceNumber: string, customerId: string, invoiceDate: Types.TDateISO, dueDate: Types.TDateISO, subtotal: number, freight: number, taxTotal: number, taxStatus: Types.InvoiceTaxStatus, grossTotal: number, depositApplied: number, total: number, issuedAt: Types.TDateISO, issuedBy: string, status: Types.InvoiceStatus, voidReason?: string | null, stripeTaxReversalTransactionId?: string | null, voidedAt?: Types.TDateISO | null, voidedBy?: string | null, amountPaid: number, amountCreditApplied: number, discountTaken: number, lateChargeAssessed: number, openBalance: number, standing: Types.InvoiceStanding, lastPaymentDate?: Types.TDateISO | null, lines: Array<{ __typename?: 'InvoiceLineData', itemId: string, itemName: string, sku: string, lineItemId: string, lineNumber: number, shippedQuantity: number, unitPrice: number, discountAmount: number, extended: number, taxAmount: number, eachesPerUnit?: number | null, units?: number | null, shippingUomLabel?: string | null }>, flatCharges: Array<{ __typename?: 'InvoiceFlatChargeEntry', id: string, name: string, amount: number }>, taxBreakdown: Array<{ __typename?: 'InvoiceTaxJurisdictionData', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }>, terms: { __typename?: 'InvoiceTermsSnapshotData', termLimitDays: number, discountDays: number, discountRate: number, lateChargeMonthlyRate: number, maxAnnualRate: number }, payments: Array<{ __typename?: 'InvoicePaymentEntry', streamRevision: number, amount: number, method: Types.InvoicePaymentMethod, transactionRef?: string | null, receivedDate: Types.TDateISO, discountTaken: number, lateChargeAssessed: number, recordedBy: string, note?: string | null, recordedAt: Types.TDateISO, paymentId?: string | null, paymentSyncStatus: Types.PaymentSyncStatus, accountingPaymentId?: string | null, syncFailureReason?: string | null }>, creditsApplied: Array<{ __typename?: 'InvoiceCreditApplicationEntry', applicationId: string, amount: number, appliedAt: Types.TDateISO, sources: Array<{ __typename?: 'InvoiceCreditSourceEntry', entryId: string, sourceKind: Types.CustomerCreditSourceKind, sourceReference: string, amount: number }> }>, quickBooksExport: { __typename?: 'QuickBooksExportState', status: Types.QuickBooksExportStatus, remoteInvoiceId?: string | null, errorMessage?: string | null, lastAttemptAt?: Types.TDateISO | null, retryCount: number, resolvedRevenueRung?: Types.MergeDevRevenueRung | null, resolvedRevenueAccount?: { __typename?: 'MergeDevAccountDocument', accountNumber: string, name: string } | null } } | null };

export type VoidedInvoiceStateFragment = { __typename?: 'InvoiceStateData', invoiceId: string, status: Types.InvoiceStatus, voidReason?: string | null, voidedAt?: Types.TDateISO | null, voidedBy?: string | null, stripeTaxReversalTransactionId?: string | null };

export type SettledInvoiceStateFragment = { __typename?: 'InvoiceStateData', invoiceId: string, balance: number, status: Types.InvoiceStatus, payments: Array<{ __typename?: 'InvoicePaymentData', paymentId?: string | null }> };

export type CreditAppliedInvoiceStateFragment = { __typename?: 'InvoiceStateData', invoiceId: string, balance: number, status: Types.InvoiceStatus, amountCreditApplied: number };

export type AdjustedInvoiceStateFragment = { __typename?: 'InvoiceStateData', invoiceId: string, amountAdjusted: number, balance: number, status: Types.InvoiceStatus };

export type LateChargeWaivedInvoiceStateFragment = { __typename?: 'InvoiceStateData', invoiceId: string, lateChargeWaived: number, balance: number, status: Types.InvoiceStatus };

export type GetCustomerNamesForInvoicesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CustomersSummaryDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetCustomerNamesForInvoicesQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomersSummaryDocument', customerId: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type InvoiceAdjustmentRowFragment = { __typename?: 'InvoiceAdjustmentEntry', adjustmentId: string, kind: Types.InvoiceAdjustmentKind, amount: number, reason: string, adjustedAt: Types.TDateISO, adjustedBy: string };

export type InvoiceLateChargeWaiverRowFragment = { __typename?: 'InvoiceLateChargeWaiverEntry', waiverId: string, amount: number, asOfDate: Types.TDateISO, reason: string, waivedAt: Types.TDateISO, waivedBy: string };

export type GetInvoiceHistoryQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['String']['input'];
}>;


export type GetInvoiceHistoryQuery = { __typename?: 'Query', invoice?: { __typename?: 'InvoiceDocument', id: string, invoiceId: string, invoiceNumber: string, amountAdjusted: number, lateChargeWaived: number, payments: Array<{ __typename?: 'InvoicePaymentEntry', streamRevision: number, amount: number, method: Types.InvoicePaymentMethod, transactionRef?: string | null, receivedDate: Types.TDateISO, discountTaken: number, lateChargeAssessed: number, recordedBy: string, note?: string | null, recordedAt: Types.TDateISO, paymentId?: string | null, paymentSyncStatus: Types.PaymentSyncStatus, accountingPaymentId?: string | null, syncFailureReason?: string | null }>, adjustments: Array<{ __typename?: 'InvoiceAdjustmentEntry', adjustmentId: string, kind: Types.InvoiceAdjustmentKind, amount: number, reason: string, adjustedAt: Types.TDateISO, adjustedBy: string }>, lateChargeWaivers: Array<{ __typename?: 'InvoiceLateChargeWaiverEntry', waiverId: string, amount: number, asOfDate: Types.TDateISO, reason: string, waivedAt: Types.TDateISO, waivedBy: string }> } | null };

export const InvoiceLineRowFragmentDoc = new TypedDocumentString(`
    fragment InvoiceLineRow on InvoiceLineData {
  itemId
  itemName
  sku
  lineItemId
  lineNumber
  shippedQuantity
  unitPrice
  discountAmount
  extended
  taxAmount
  eachesPerUnit
  units
  shippingUomLabel
}
    `, {"fragmentName":"InvoiceLineRow"});
export const InvoiceTaxJurisdictionRowFragmentDoc = new TypedDocumentString(`
    fragment InvoiceTaxJurisdictionRow on InvoiceTaxJurisdictionData {
  jurisdiction
  level
  state
  rate
  amount
  taxableAmount
  reason
}
    `, {"fragmentName":"InvoiceTaxJurisdictionRow"});
export const InvoiceTermsRowFragmentDoc = new TypedDocumentString(`
    fragment InvoiceTermsRow on InvoiceTermsSnapshotData {
  termLimitDays
  discountDays
  discountRate
  lateChargeMonthlyRate
  maxAnnualRate
}
    `, {"fragmentName":"InvoiceTermsRow"});
export const InvoicePaymentRowFragmentDoc = new TypedDocumentString(`
    fragment InvoicePaymentRow on InvoicePaymentEntry {
  streamRevision
  amount
  method
  transactionRef
  receivedDate
  discountTaken
  lateChargeAssessed
  recordedBy
  note
  recordedAt
  paymentId
  paymentSyncStatus
  accountingPaymentId
  syncFailureReason
}
    `, {"fragmentName":"InvoicePaymentRow"});
export const InvoiceCreditApplicationRowFragmentDoc = new TypedDocumentString(`
    fragment InvoiceCreditApplicationRow on InvoiceCreditApplicationEntry {
  applicationId
  amount
  appliedAt
  sources {
    entryId
    sourceKind
    sourceReference
    amount
  }
}
    `, {"fragmentName":"InvoiceCreditApplicationRow"});
export const QuickBooksExportStateRowFragmentDoc = new TypedDocumentString(`
    fragment QuickBooksExportStateRow on QuickBooksExportState {
  status
  remoteInvoiceId
  errorMessage
  lastAttemptAt
  retryCount
  resolvedRevenueRung
  resolvedRevenueAccount {
    accountNumber
    name
  }
}
    `, {"fragmentName":"QuickBooksExportStateRow"});
export const InvoiceDetailFragmentDoc = new TypedDocumentString(`
    fragment InvoiceDetail on InvoiceDocument {
  id
  invoiceId
  orderId
  invoiceNumber
  customerId
  invoiceDate
  dueDate
  lines {
    ...InvoiceLineRow
  }
  subtotal
  freight
  flatCharges {
    id
    name
    amount
  }
  taxTotal
  taxBreakdown {
    ...InvoiceTaxJurisdictionRow
  }
  taxStatus
  grossTotal
  depositApplied
  total
  terms {
    ...InvoiceTermsRow
  }
  issuedAt
  issuedBy
  status
  voidReason
  stripeTaxReversalTransactionId
  voidedAt
  voidedBy
  payments {
    ...InvoicePaymentRow
  }
  amountPaid
  amountCreditApplied
  creditsApplied {
    ...InvoiceCreditApplicationRow
  }
  discountTaken
  lateChargeAssessed
  openBalance
  standing
  lastPaymentDate
  quickBooksExport {
    ...QuickBooksExportStateRow
  }
}
    fragment InvoiceLineRow on InvoiceLineData {
  itemId
  itemName
  sku
  lineItemId
  lineNumber
  shippedQuantity
  unitPrice
  discountAmount
  extended
  taxAmount
  eachesPerUnit
  units
  shippingUomLabel
}
fragment InvoiceTaxJurisdictionRow on InvoiceTaxJurisdictionData {
  jurisdiction
  level
  state
  rate
  amount
  taxableAmount
  reason
}
fragment InvoiceTermsRow on InvoiceTermsSnapshotData {
  termLimitDays
  discountDays
  discountRate
  lateChargeMonthlyRate
  maxAnnualRate
}
fragment InvoicePaymentRow on InvoicePaymentEntry {
  streamRevision
  amount
  method
  transactionRef
  receivedDate
  discountTaken
  lateChargeAssessed
  recordedBy
  note
  recordedAt
  paymentId
  paymentSyncStatus
  accountingPaymentId
  syncFailureReason
}
fragment QuickBooksExportStateRow on QuickBooksExportState {
  status
  remoteInvoiceId
  errorMessage
  lastAttemptAt
  retryCount
  resolvedRevenueRung
  resolvedRevenueAccount {
    accountNumber
    name
  }
}
fragment InvoiceCreditApplicationRow on InvoiceCreditApplicationEntry {
  applicationId
  amount
  appliedAt
  sources {
    entryId
    sourceKind
    sourceReference
    amount
  }
}`, {"fragmentName":"InvoiceDetail"});
export const VoidedInvoiceStateFragmentDoc = new TypedDocumentString(`
    fragment VoidedInvoiceState on InvoiceStateData {
  invoiceId
  status
  voidReason
  voidedAt
  voidedBy
  stripeTaxReversalTransactionId
}
    `, {"fragmentName":"VoidedInvoiceState"});
export const SettledInvoiceStateFragmentDoc = new TypedDocumentString(`
    fragment SettledInvoiceState on InvoiceStateData {
  invoiceId
  balance
  status
  payments {
    paymentId
  }
}
    `, {"fragmentName":"SettledInvoiceState"});
export const CreditAppliedInvoiceStateFragmentDoc = new TypedDocumentString(`
    fragment CreditAppliedInvoiceState on InvoiceStateData {
  invoiceId
  balance
  status
  amountCreditApplied
}
    `, {"fragmentName":"CreditAppliedInvoiceState"});
export const AdjustedInvoiceStateFragmentDoc = new TypedDocumentString(`
    fragment AdjustedInvoiceState on InvoiceStateData {
  invoiceId
  amountAdjusted
  balance
  status
}
    `, {"fragmentName":"AdjustedInvoiceState"});
export const LateChargeWaivedInvoiceStateFragmentDoc = new TypedDocumentString(`
    fragment LateChargeWaivedInvoiceState on InvoiceStateData {
  invoiceId
  lateChargeWaived
  balance
  status
}
    `, {"fragmentName":"LateChargeWaivedInvoiceState"});
export const InvoiceAdjustmentRowFragmentDoc = new TypedDocumentString(`
    fragment InvoiceAdjustmentRow on InvoiceAdjustmentEntry {
  adjustmentId
  kind
  amount
  reason
  adjustedAt
  adjustedBy
}
    `, {"fragmentName":"InvoiceAdjustmentRow"});
export const InvoiceLateChargeWaiverRowFragmentDoc = new TypedDocumentString(`
    fragment InvoiceLateChargeWaiverRow on InvoiceLateChargeWaiverEntry {
  waiverId
  amount
  asOfDate
  reason
  waivedAt
  waivedBy
}
    `, {"fragmentName":"InvoiceLateChargeWaiverRow"});
export const GetInvoiceNumbersForHistoryDocument = new TypedDocumentString(`
    query GetInvoiceNumbersForHistory($where: InvoiceDocumentFilterInput, $order: [InvoiceDocumentSortInput!], $first: Int, $after: String) {
  invoices(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      invoiceId
      invoiceNumber
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetInvoiceDocument = new TypedDocumentString(`
    query GetInvoice($invoiceId: String!) {
  invoice(invoiceId: $invoiceId) {
    ...InvoiceDetail
  }
}
    fragment InvoiceLineRow on InvoiceLineData {
  itemId
  itemName
  sku
  lineItemId
  lineNumber
  shippedQuantity
  unitPrice
  discountAmount
  extended
  taxAmount
  eachesPerUnit
  units
  shippingUomLabel
}
fragment InvoiceTaxJurisdictionRow on InvoiceTaxJurisdictionData {
  jurisdiction
  level
  state
  rate
  amount
  taxableAmount
  reason
}
fragment InvoiceTermsRow on InvoiceTermsSnapshotData {
  termLimitDays
  discountDays
  discountRate
  lateChargeMonthlyRate
  maxAnnualRate
}
fragment InvoicePaymentRow on InvoicePaymentEntry {
  streamRevision
  amount
  method
  transactionRef
  receivedDate
  discountTaken
  lateChargeAssessed
  recordedBy
  note
  recordedAt
  paymentId
  paymentSyncStatus
  accountingPaymentId
  syncFailureReason
}
fragment QuickBooksExportStateRow on QuickBooksExportState {
  status
  remoteInvoiceId
  errorMessage
  lastAttemptAt
  retryCount
  resolvedRevenueRung
  resolvedRevenueAccount {
    accountNumber
    name
  }
}
fragment InvoiceCreditApplicationRow on InvoiceCreditApplicationEntry {
  applicationId
  amount
  appliedAt
  sources {
    entryId
    sourceKind
    sourceReference
    amount
  }
}
fragment InvoiceDetail on InvoiceDocument {
  id
  invoiceId
  orderId
  invoiceNumber
  customerId
  invoiceDate
  dueDate
  lines {
    ...InvoiceLineRow
  }
  subtotal
  freight
  flatCharges {
    id
    name
    amount
  }
  taxTotal
  taxBreakdown {
    ...InvoiceTaxJurisdictionRow
  }
  taxStatus
  grossTotal
  depositApplied
  total
  terms {
    ...InvoiceTermsRow
  }
  issuedAt
  issuedBy
  status
  voidReason
  stripeTaxReversalTransactionId
  voidedAt
  voidedBy
  payments {
    ...InvoicePaymentRow
  }
  amountPaid
  amountCreditApplied
  creditsApplied {
    ...InvoiceCreditApplicationRow
  }
  discountTaken
  lateChargeAssessed
  openBalance
  standing
  lastPaymentDate
  quickBooksExport {
    ...QuickBooksExportStateRow
  }
}`);
export const GetCustomerNamesForInvoicesDocument = new TypedDocumentString(`
    query GetCustomerNamesForInvoices($where: CustomersSummaryDocumentFilterInput, $first: Int) {
  customers(where: $where, first: $first) {
    nodes {
      customerId
      name
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetInvoiceHistoryDocument = new TypedDocumentString(`
    query GetInvoiceHistory($invoiceId: String!) {
  invoice(invoiceId: $invoiceId) {
    id
    invoiceId
    invoiceNumber
    amountAdjusted
    lateChargeWaived
    payments {
      ...InvoicePaymentRow
    }
    adjustments {
      ...InvoiceAdjustmentRow
    }
    lateChargeWaivers {
      ...InvoiceLateChargeWaiverRow
    }
  }
}
    fragment InvoicePaymentRow on InvoicePaymentEntry {
  streamRevision
  amount
  method
  transactionRef
  receivedDate
  discountTaken
  lateChargeAssessed
  recordedBy
  note
  recordedAt
  paymentId
  paymentSyncStatus
  accountingPaymentId
  syncFailureReason
}
fragment InvoiceAdjustmentRow on InvoiceAdjustmentEntry {
  adjustmentId
  kind
  amount
  reason
  adjustedAt
  adjustedBy
}
fragment InvoiceLateChargeWaiverRow on InvoiceLateChargeWaiverEntry {
  waiverId
  amount
  asOfDate
  reason
  waivedAt
  waivedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetInvoiceNumbersForHistory: build.query<GetInvoiceNumbersForHistoryQuery, GetInvoiceNumbersForHistoryQueryVariables | void>({
      query: (variables) => ({ document: GetInvoiceNumbersForHistoryDocument, variables })
    }),
    GetInvoice: build.query<GetInvoiceQuery, GetInvoiceQueryVariables>({
      query: (variables) => ({ document: GetInvoiceDocument, variables })
    }),
    GetCustomerNamesForInvoices: build.query<GetCustomerNamesForInvoicesQuery, GetCustomerNamesForInvoicesQueryVariables | void>({
      query: (variables) => ({ document: GetCustomerNamesForInvoicesDocument, variables })
    }),
    GetInvoiceHistory: build.query<GetInvoiceHistoryQuery, GetInvoiceHistoryQueryVariables>({
      query: (variables) => ({ document: GetInvoiceHistoryDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetInvoiceNumbersForHistoryQuery, useLazyGetInvoiceNumbersForHistoryQuery, useGetInvoiceQuery, useLazyGetInvoiceQuery, useGetCustomerNamesForInvoicesQuery, useLazyGetCustomerNamesForInvoicesQuery, useGetInvoiceHistoryQuery, useLazyGetInvoiceHistoryQuery } = injectedRtkApi;
